import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { mapSetter } from 'commons/vuex/map/map.js';
import { getPage } from './state.js';

export const mutations = {
    [MUTATIONS.SET_PAGE]: mapSetter(Vue, getPage),
};
